var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 49 49"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M39.256 6.5H9.744C4.371 6.5 0 10.885 0 16.274v16.451c0 5.39 4.371 9.774 9.744 9.774h29.512c5.373 0 9.744-4.385 9.744-9.774V16.274c0-5.389-4.371-9.774-9.744-9.774M47 32.726c0 4.287-3.474 7.774-7.744 7.774H9.744C5.474 40.5 2 37.012 2 32.726V16.274C2 11.988 5.474 8.5 9.744 8.5h29.512c4.27 0 7.744 3.488 7.744 7.774z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m33.36 24.138-13.855-8.115a1.002 1.002 0 0 0-1.505.863v16.229a1 1 0 0 0 1 1 1 1 0 0 0 .505-.137l13.855-8.113a1 1 0 0 0 0-1.727M20 31.37V18.63l10.876 6.371z"
})));
export default SvgYoutube;